import styled from 'styled-components'

const cellHeight = 26

export const Container = styled.button`
  display: flex;
  height: ${({ timeInterval, professional }) => (
    cellHeight * (professional?.time_interval / timeInterval) - 1 + 'px'
  )};
  background-color: ${({ isDraggingOver }) => isDraggingOver ? '#F0F0F0': 'transparent'};
  border: ${({ isDraggingOver }) => isDraggingOver ? '1px solid #FFFFFF': '0px'};
  margin: 1px 0px 0px;
  border-radius: 8px;
  text-decoration: none;
  justify-content: center;
  align-items: center;

  p {display: ${({ isDraggingOver }) => isDraggingOver ? 'block': 'none'};}

  &:hover {
    background-color: #F0F0F0;
    border: 1px solid #FFFFFF;
    p {display: block;}
  }

  &:before {
    content: '';
    background-color: #CCCCCC;
    position: absolute;
    top: 0px;
    margin-left: 0px;
    margin-right: calc((100vw - 437px) / ${({ numColumns }) => numColumns});
    width: 1px;
    height: ${({ timeInterval, professional }) => (
      `calc(100% - ${cellHeight * (professional?.time_interval / timeInterval)}px)`
    )};
  }
  
  &:after {
    content: '';
    background-color: #CCCCCC;
    position: absolute;
    top: 0px;
    margin-left: calc((100vw - 437px) / ${({ numColumns }) => numColumns});
    margin-right: 0px;
    width: 1px;
    height: calc(100% - ${cellHeight}px);
    height: ${({ timeInterval, professional }) => (
      `calc(100% - ${cellHeight * (professional?.time_interval / timeInterval)}px)`
    )};
  }
`

export const InfoText = styled.p`
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #000000;
  margin: 0px;
`
